/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Card } from "@lightspeed/flame/Card";
import { useSelector } from "react-redux";

import quickbooksIcon from "../home/assets/icons/quickbooks.png";
import xeroIcon from "../home/assets/icons/xero.png";
import sageIcon from "../home/assets/icons/sage.png";

const Dash = () => {
  const userState = useSelector((state) => state.userState);
  const [quantity, setQuantity] = useState(1);

  const activeIntegration = "xero"; // simulacija

  useEffect(() => {
    document.body.style.backgroundColor = "#ffffff";
    document.documentElement.style.backgroundColor = "#ffffff";
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        backgroundColor: "#ffffff",
        gap: "30px",
      }}
    >
      {/* Welcome dio — sada potpuno ulijevo */}
      <div
        style={{
          alignSelf: "flex-start",
          marginLeft: "5%",
          marginBottom: "10px",
        }}
      >
        <h2 style={{ fontSize: "2.5rem", fontWeight: "600", color: "#1a1a1a" }}>
          Welcome
        </h2>
        <p style={{ fontSize: "0.9rem", color: "#666", whiteSpace: "nowrap" }}>
          USER ID: {(String(userState?.user?.user_id ?? "")).replace(/[\r\n]+/g, "")}
        </p>

      </div>

      
 
    </div>
  );
};

export default Dash;
